import { useEffect, useState } from "react";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import CareerPortalBanner from "../StudentPage/CareerPortalBanner";
import Sidebar from "../../Components/Student page/Sidebar";
import Navbar from "../../Components/Student page/Navbar";
import DashboardCards from "../../Components/Student page/DashboardCards";
import SearchBar from "../../Components/Student page/SearchBar";
import CourseTable from "../../Components/Student page/Coursetable";
import OfferBanner from "../../Components/Student page/Offerbanner";
import Certification from "../../Components/Student page/Certification";
import CareerSection from "../../Components/Student page/CarrerSection";
import StudentProfile from "../../Components/Student page/StudentProfile";

function StudentDashboard() {
  const [searchQuery, setSearchQuery] = useState("");
  const [filterMode, setFilterMode] = useState("All");
  const [student, setStudent] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("student")) || null;
    } catch (_error) {
      return null;
    }
  });

  useEffect(() => {
    AOS.init({
      duration: 750,
      once: true,
      offset: 30,
      easing: "ease-out-cubic",
    });

    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get("http://localhost:5000/api/auth/profile", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => {
        setStudent(data.student);
        localStorage.setItem("student", JSON.stringify(data.student));
      })
      .catch(() => {});
  }, []);

  return (
    <>
      <Sidebar />

      <Navbar student={student} />

      <DashboardCards />

      <SearchBar
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        filterMode={filterMode}
        setFilterMode={setFilterMode}
      />

      <CourseTable searchQuery={searchQuery} filterMode={filterMode} />

      <OfferBanner />

      <Certification />

<CareerSection />

<CareerPortalBanner />

<StudentProfile student={student} />
    </>
  );
}

export default StudentDashboard;
